import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import React from 'react';
import {Popover, OverlayTrigger} from 'react-bootstrap';
import Loading from '../../misc/Loading';
import PublishStatusDot from '../../../../misc/PublishStatusDot.js';
import PublishStatusTableRow from '../../table/PublishStatusTableRow.js';

class Articles extends React.Component {
  printButtonGroup() {
    return (
      <div className="pull-right">
        {this.props.working &&
          <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
        }
        {this.props.handleToggleShowArchived &&
          <button
            className="btn btn-info"
            onClick={(e) => {
              e.preventDefault();
              this.props.handleToggleShowArchived();
            }}>
            {this.props.showArchived ? 'Gjem arkiverte artikler' : 'Vis arkiverte artikler'}
          </button>
        }
        &nbsp;
        &nbsp;
        <Link
          to={'/motorforum/articles/new'}
          className="btn btn-success"
          disabled={this.props.working}
        >
          Ny artikkel
        </Link>
      </div>
    );
  }

  printPager() {
    if (!this.props.articles.length) {
      return;
    }

    if (!this.props.total || this.props.total <= this.props.limit) {
      return;
    }

    const pages = Math.ceil(this.props.total / this.props.limit);

    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * this.props.limit);
    }

    const lastOffset = offsets[offsets.length - 1];

    if (this.props.total && this.props.total > this.props.limit) {
      return <ul className="pagination">
        <li className={(this.props.offset === 0 || this.props.working) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.handleSetOffset(0);
            }}
            aria-label="Previous"
            disabled={this.props.working}
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        {offsets.map((offset, i) => {
          return <li key={`page-${i}`} className={this.props.offset === offset ? 'active' : (this.props.working ? ' disabled' : '')}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleSetOffset(offset);
              }}
              disabled={this.props.working}
            >
              {i + 1}
            </a>
          </li>;
        })}

        <li className={((this.props.offset + this.props.limit) > this.props.total || this.props.working) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.handleSetOffset(lastOffset);
            }}
            aria-label="Next"
            disabled={this.props.working}>
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>;
    }
  }

  printVisibleMyPage(count) {
    if (count > 0) {
      return <div><i className="text-success fa fa-check mf-padding-right-10"></i> ({count})</div>;
    }

    return <i className="text-danger fa fa-times"></i>;
  }

  printVisibleDealers(article) {
    const icons = [];
    // Check dates
    const now = Date.now();
    const fromDateValid = (!article.fromDate || article.fromDate.getTime() <= now);
    const toDateValid = (!article.toDate || article.toDate.getTime() >= now);

    if (article.criticalBannerArticle) {
      icons.push(<i key="critical" className="text-success fa fa-exclamation mf-padding-right-10" title="Kritisk artikkel"></i>);
    }

    if (article.dealerIds.length > 0 && article.pages.length > 0 && fromDateValid && toDateValid) {
      icons.push(<i key="ok" className="text-success fa fa-check mf-padding-right-10"></i>);
      return icons;
    }

    if (article.dealerIds.length <= 0) {
      icons.push(<i key="errorDealer" className="text-danger fa fa-times mf-padding-right-10" title="Mangler forhandlere"></i>);
    }
    if (article.pages.length <= 0) {
      icons.push(<i key="errorSections" className="text-danger fa fa-file-o mf-padding-right-10" title="Mangler seksjoner/sider"></i>);
    }
    if (!fromDateValid || !toDateValid) {
      icons.push(<i key="errorDates" className="text-danger fa fa-calendar mf-padding-right-10" title="Utenfor tidsrom for publisering"></i>);
    }

    return icons;
  }

  render() {
    if (this.props.articles) {
      if (this.props.articles.length !== 0) {
        const popoverDealers = (
          <Popover id="popover-dealers" title="Forhandlersider">
            For å være synlig på motorforum må artikkelen være publisert til en eller flere forhandlere, samt være publisert til en eller flere seksjoner.<br/>
            Dersom datoer for publisering er satt, må også dagens dato falle mellom fra- og tildato for at artikkelen skal være synlig.
          </Popover>
        );
        const overlayDealers = <OverlayTrigger trigger={['hover', 'click', 'focus']} placement="left" overlay={popoverDealers}>
          <i className="fa fa-question-circle"></i>
        </OverlayTrigger>;

        let sortIconClass;
        let sortType;
        let priClickSort = '-fields.priority';

        switch (this.props.sort) {
          case 'fields.priority':
            sortIconClass = 'fa-arrow-up';
            sortType = 'pri';
            break;
          case '-fields.priority':
            sortIconClass = 'fa-arrow-down';
            priClickSort = 'fields.priority';
            sortType = 'pri';
            break;
        }

        return (
          <section className="article mf-padding-top-20">
            <ol className="breadcrumb">
              <li><Link to="/">Forsiden</Link></li>
              <li>Motorforum</li>
              <li className="active">Artikler</li>
            </ol>

            <div className="page-header">
              {this.printButtonGroup()}
              <h1>Artikler</h1>
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th title="Publiseringsstatus"></th>
                    <th>Tittel</th>
                    <th>Intern Sammendrag</th>
                    <th>
                      <a href="#" onClick={() => this.props.handleSort(priClickSort)}>
                        Pri{sortType === 'pri' && sortIconClass && <i className={`fa ${sortIconClass}`} aria-hidden="true"></i>}
                      </a>
                    </th>
                    <th>Synlig på motorforum? {overlayDealers}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.articles.map((article) => {
                    return (
                      <PublishStatusTableRow entry={article} key={`article-${article.id}`}>
                        <td className="text-center">
                          <PublishStatusDot entry={article} />
                        </td>
                        <td>
                          <Link to={`/motorforum/articles/${article.id}`}>{article.title}</Link>
                        </td>
                        <td>
                          {article.summary}
                        </td>
                        <td>
                          {article.priority}
                        </td>
                        <td>
                          {this.printVisibleDealers(article)}
                        </td>
                      </PublishStatusTableRow>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="text-center">
              {this.printPager()}
            </div>
          </section>
        );
      }

      return (
        <section className="campaign mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li className="active">Artikler</li>
          </ol>

          <div className="page-header">
            {this.printButtonGroup()}
            <h1>Artikler</h1>
          </div>
          <div className="alert alert-warning">
            Fant ingen Artikler
          </div>
        </section>
      );
    }
    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li className="active">Artikler</li>
        </ol>
        <Loading title="Artikler" text="Laster artikler"/>
      </section>
    );
  }
}

Articles.defaultProps = {
};

export default withRouter(Articles);
